module.exports = __webpack_public_path__ + "files/d8868b9d2fb25703c46e5e7c1d5d78e1.svg";